import { render, staticRenderFns } from "./bugDialog.vue?vue&type=template&id=d9ef8d6a&scoped=true"
import script from "./bugDialog.vue?vue&type=script&lang=ts"
export * from "./bugDialog.vue?vue&type=script&lang=ts"
import style0 from "./bugDialog.vue?vue&type=style&index=0&id=d9ef8d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef8d6a",
  null
  
)

export default component.exports